import moment from "moment";

export const dateToStringFilter = (value: string, displayTime: boolean = true): string => {
    if (value !== null && value !== undefined) {
        return moment(value).format(`MMM Do YYYY${displayTime ? " - HH:mm" : ""}`);
    } else {
        return "";
    }
};
